import createMailFolderTableQuery from 'mini-mail-list-store/lib/utils/tables/createMailFolderTableQuery';
import type FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import getTableViewFromTableQuery from 'mini-mail-list-store/lib/actions/tables/getTableViewFromTableQuery';
import loadTableViewFromTableQuery from './tables/loadTableViewFromTableQuery';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action } from 'satcheljs/lib/legacy';
import { ACTION_SELECT_FOCUSED_PIVOT } from '../utils/actionNames';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { lazyCreateSuggestedUnsubscribeItems } from 'mini-mail-suggested-unsubscribe-store';
import { lazyUpdateWatermarkAndReset } from 'mini-mail-focused-inbox-rollup-store';
import type { MailHeaderElementToFocus } from 'mini-mail-list-store/lib/store/schema/MailHeaderElementToFocus';
import { BINARY_SWITCH } from 'mini-mail-list-store/lib/store/schema/MailHeaderElementToFocus';

// Select focused pivot
export default action(ACTION_SELECT_FOCUSED_PIVOT)(async function selectFocusedPivot(
    focusedViewFilter: FocusedViewFilter,
    sourceElement: MailHeaderElementToFocus = BINARY_SWITCH
) {
    // Update last visited watermark for selected pivot and reset rollup store
    lazyUpdateWatermarkAndReset.importAndExecute(focusedViewFilter);

    // Assigning the focused view filter to MailStore folders object
    // so that it can be used in selectFolder to restore the focused pivot state when exiting search module.
    if (mailStore.folders) {
        mailStore.folders.selectedFocusedViewFilter = focusedViewFilter;
    }

    // Always reset the view filter when user switches the focused pivot
    const tableQuery = createMailFolderTableQuery(
        getSelectedFolderId(),
        focusedViewFilter,
        'All',
        sourceElement
    );
    const loadedTableView = await loadTableViewFromTableQuery(tableQuery);

    if (isMiniFeatureEnabled('mini-suggested-unsubscribe') && focusedViewFilter === 1) {
        lazyCreateSuggestedUnsubscribeItems.importAndExecute(
            getTableViewFromTableQuery(tableQuery)
        );
    }

    return loadedTableView;
});
